<template>
  <div class="app-layout">
    <div class="app-header" style="background-color: var(--color-background)">
      <div class="app-header-content">
        <div class="app-header-title">
          <img src="@/assets/logo.png" class="app-logo" alt="Sequins Logo" />
          <h1>
            Sequins
            <small>Inventory Management System</small>
          </h1>
        </div>
        <small class="app-header-version">v{{ appVersion }}</small>
      </div>
      <UserPanel v-if="loggedIn" />
    </div>

    <n-layout-content :has-sider="loggedIn">
      <div class="app-main">
        <n-layout-sider
          v-if="loggedIn"
          bordered
          class="app-sider"
          collapse-mode="width"
          width="180"
          :collapsed-width="55"
        >
          <MainNavigation />

          <n-tooltip placement="right" trigger="hover">
            <template #trigger>
              <n-float-button class="app-float-btn" @click="showReportModal = true">
                <n-icon class="float-btn-icon">
                  <Bug />
                </n-icon>
              </n-float-button>
            </template>
            Report
          </n-tooltip>
        </n-layout-sider>
        <n-layout class="app-content">
          <slot />
        </n-layout>
      </div>
    </n-layout-content>

    <n-modal
      v-model:show="showReportModal"
      mask-closable
      close-on-esc
      preset="card"
      title="Report Bug"
      :style="{ maxWidth: '600px', height: '90vh' }"
    >
      <iframe
        :src="reportPageSrc"
        class="app-report-iframe"
        frameborder="0"
        title="Report System"
      ></iframe>
    </n-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Bug } from '@vicons/ionicons5'
import {
  NFloatButton,
  NIcon,
  NLayout,
  NLayoutContent,
  NLayoutSider,
  NModal,
  NTooltip,
} from 'naive-ui'

import UserPanel from './UserPanel.vue'
import MainNavigation from './MainNavigation.vue'

const appVersion = __APP_VERSION__

// Reactive state for the iframe modal
const showReportModal = ref(false)
const reportPageSrc = import.meta.env.BASE_URL + 'bug-report-frame.html'

defineProps({
  loggedIn: { type: Boolean, default: false },
})
</script>

<style scoped>
.app-sider {
  height: 100%;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
  background-color: var(--color-background-mute);
}

.app-main {
  display: flex;
  width: 100%;
  min-height: 100vh;
  padding: 90px 0 0 0;
}

.app-header-content {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 16px;
}

.app-header-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
  line-height: 1.1;
  min-width: 300px;

  small {
    display: block;
    font-size: 1rem;
    font-weight: 400;
  }
}

.app-header-version {
  font-style: italic;
  color: var(--color-mark);
}

.app-layout {
  height: 100%;
}

.app-content {
  padding: 16px 24px;
  background-color: var(--color-background);
}

.app-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  height: 90px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  border-bottom: 1px solid var(--color-border);
  align-items: center;
}

.app-logo {
  height: 50px;
  line-height: 50px;
  font-size: 1.5rem;
  font-weight: 700;
}

.app-float-btn {
  bottom: 16px;
  left: 16px;
}

.float-btn-icon {
  font-size: 24px;
}

/* Jira Report Iframe styles */
.app-report-iframe {
  width: 100%;
  height: 100%;
  min-height: 60vh;
  border: none;
  border-radius: 8px;
}
</style>
